import { IEReservationIntervalElement } from "modules/appointment/types/IEReservationIntervalElement";
import { IAppointmentDetails } from "modules/user/application/types/IAppointmentDetails";

import { Button, CustomColorScheme, IButtonProps } from "components/Button";
import { ChakraText } from "components/ChakraText";
import { useModal } from "components/Modal";

import { EditUserAppointmentConfirmationModal } from "./EditUserAppointmentConfirmationModal";

interface IProps extends Pick<IButtonProps, "disabled"> {
  intervalElement: IEReservationIntervalElement | null;
  appointment: IAppointmentDetails;
}

const EditUserAppointment = ({ appointment, intervalElement }: IProps) => {
  const { isOpen, onOpen, onClose } = useModal();
  return (
    <>
      {intervalElement && (
        <EditUserAppointmentConfirmationModal
          appointment={appointment}
          intervalElement={intervalElement}
          onClose={onClose}
          isOpen={isOpen}
        />
      )}

      <Button
        customColorScheme={CustomColorScheme.Green}
        disabled={!intervalElement}
        h="80px"
        w="300px"
        onClick={onOpen}
        id="confirm-edit-appointment-btn"
      >
        <ChakraText>Potwierdź zmianę terminu</ChakraText>
      </Button>
    </>
  );
};

export { EditUserAppointment };
